import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserCommonService } from '../../services/user-common.service';
import { UiService } from '../../services/ui.service';
import { AppSettings } from '../../app.settings';
import { ErrorBindingService } from '../../services/error-binding.service';
import { CommonBindingDataService } from '../../services/common-binding-data.service';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {


  @Input() userId: String;
  @Output() closePasswordDialog: EventEmitter<any> = new EventEmitter();
  @Output() closeSuccessUpdatePassword: EventEmitter<any> = new EventEmitter();
  setPasswordForm: UntypedFormGroup;
  inputType = 'password';
  cnfInputType = 'password';
  @Input() isShuttle = false;
  changePasswordErrors = [
    {
      newPassword: false,
      newConfirmPassword: false,
    }
  ];
  constructor(
    private formBuilder: FormBuilder,
    private userCommonService: UserCommonService,
    private uiService: UiService,
    private commonService: CommonBindingDataService,
    private errorBindingService: ErrorBindingService
  ) { }

  ngOnInit() {
    this.setPasswordForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.minLength(8),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS)]],
      newConfirmPassword: ['', [Validators.required, Validators.minLength(8),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS)]]
    });
  }

  passwordNotMatched() {
    if (this.setPasswordForm.controls.newPassword.value !== this.setPasswordForm.controls.newConfirmPassword.value) {
      const error = {
        general: [
          {
            message: this.commonService.getLabel('error_new_confirm_password_not_match')
          }
        ]
      };
      this.errorBindingService.onAPIValidationError(error, this.changePasswordErrors);
    } else {
      return true;
    }
  }

  requestData() {
    return {
      password: this.setPasswordForm.controls.newPassword.value,
    };
  }

  doChangePassword() {
    const passwordVerified = this.passwordNotMatched();
    if (passwordVerified) {
      const data = this.requestData();
      const c = this;
      if(this.isShuttle) {
        this.userCommonService.updatePasswordShuttleDriver(JSON.stringify(data), this.userId).subscribe(results => {
          if (results.general !== null && results.general !== undefined) {
            results.general.forEach(element => {
              this.uiService.showMessage(element.message, AppSettings.MESSAGE_TYPE.SUCCESS);
            });
            this.setPasswordForm.reset();
            setTimeout(() => {
              this.onCancel();
            }, 500);
          }
        }, (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        }); 
      } else {
        this.userCommonService.updatePassword(JSON.stringify(data), this.userId).subscribe(results => {
          if (results.general !== null && results.general !== undefined) {
            results.general.forEach(element => {
              this.uiService.showMessage(element.message, AppSettings.MESSAGE_TYPE.SUCCESS);
            });
            this.setPasswordForm.reset();
            setTimeout(() => {
              this.onCancel();
            }, 500);
          }
        }, (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        });  
      }
    }

  }

  tooglePasswordType() {
    if (this.inputType === 'password') {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }

  toogleCnfPasswordType() {
    if (this.cnfInputType === 'password') {
      this.cnfInputType = 'text';
    } else {
      this.cnfInputType = 'password';
    }
  }

  onCancel() {
    this.setPasswordForm.reset();
    this.closePasswordDialog.emit(false);
    this.closeSuccessUpdatePassword.emit(false);
  }

}
